import React from 'react';
import { string } from 'prop-types';
import { get, filter, includes, head, lowerCase } from 'lodash';
import { FlexContainer } from '../../layouts/Wrapper/Base.components';
import Icon from '../Icon';

const SlaIcon = ({ sla }) => {
    const slas = [
        { selectedSla: ['express', 'despacho express'], name: 'despachoExpress', label: 'Despacho Express', color: 'rgba(255, 104, 0, 0.6)' },
        { selectedSla: ['domicilio', 'especial', 'dinamico', 'despacho a domicilio', 'despacho especial', 'despacho especial 1000', 'despacho especial 1500', 'despacho dinamico'], name: 'despachoDomicilio', label: 'Agendamiento', color: 'rgba(77, 174, 169, 0.77)' },
        { selectedSla: ['auto', 'retiro al auto', 'click al auto'], name: 'clickAlAuto', label: 'Retiro en auto', color: '#f8da76' },
        { selectedSla: ['tienda', 'retiro en tienda'], name: 'retiroEnTienda', label: 'Retiro en tienda', color: '#cb93cc' }
    ];

    const getSlaField = field => get(head(filter(slas, ({ selectedSla }) => includes(selectedSla, lowerCase(sla)))), field, '');

    return (
        <FlexContainer
            width={32}
            height={32}
            borderRadius={4}
            backgroundColor={getSlaField('color')}
            align='center'
            justify='center'
            mR={7}
        >
            <Icon name={getSlaField('name')} color='#ffffff' size={23} />
        </FlexContainer>
    );
};

SlaIcon.propTypes = {
    sla: string
};

SlaIcon.defaultProps = {
    sla: ''
};

export default SlaIcon;
